/**
 * Created by andrey on 22.08.17.
 */

const LevelStartWindow = CleverappsWindow.extend({
    onWindowLoaded: function (options) {
        this.options = options;
        this.level = options.level;

        this.isHardLevel = this.level.isHard();

        if (options.boostersBefore) {
            this.boostersBefore = new WindowBoostersBefore(this.level);
            cleverapps.focusManager.showControlsWhileFocused("MenuBarGoldItem");
        }

        const styles = cleverapps.styles.LevelStartWindow;
        const layoutStyles = this.isLanternStartWindow() ? styles.lanternStart : styles;

        const content = new cleverapps.Layout(this.listContent(), {
            direction: cleverapps.UI.VERTICAL,
            reversed: true,
            margin: layoutStyles.margin,
            padding: layoutStyles.padding
        });

        this._super({
            title: this.getTitle(),
            name: "levelstartwindow",
            content,
            button: this.getButton(),
            level: this.level,
            closeButton: !cleverapps.environment.isGameScene(),
            showSound: this.getShowSound()
        });

        if (styles.hardLevel && this.isHardLevel) {
            const hardLevelIcon = new HardLevelWindowIcon();
            hardLevelIcon.setAlignment(styles.hardLevel);

            if (styles.hardLevel.pulseUp) {
                hardLevelIcon.pulseAnimation();
            }

            this.window.addChild(hardLevelIcon, 1);
        }

        const badge = this.createCoinBadge({
            danger: this.level.isDanger(),
            lantern: this.level.isBonus() && this.isLanternStartWindow()
        });

        if (badge) {
            this.window.addChild(badge, 1);
        }

        this.setCoinsRain();
    },

    onResize: function () {
        this._super();

        if (this.coinBadgeLabel) {
            this.coinBadgeLabel.stopAllActions();
        }
    },

    getPerson: function () {
        return "hero";
    },

    getShowSound: function () {
        if (this.level.isBonus()) {
            return bundles.main.urls.levelstartwindow_open_bonus_effect;
        }
        if (this.level.isHard()) {
            return bundles.main.urls.levelstartwindow_open_hard_effect;
        }
    },

    onPopUpAnimationFinished: function () {
        if (this.boostersBefore) {
            this.boostersBefore.showTutorialSteps();
        }
    },

    onClose: function () {
        cleverapps.focusManager.hideControlsWhileFocused("MenuBarGoldItem");

        if (this.coinsRain) {
            this.coinsRain.removeFromParent();
            this.coinsRain = undefined;
        }
    },

    getTitle: function () {
        return {
            text: this.getTitleMessage(),
            font: cleverapps.styles.FONTS.WINDOW_TITLE_TEXT
        };
    },

    getTitleMessage: function () {
        const mission = this.level.isRegular() && cleverapps.user.getFakeLevelsMission();
        if (mission && mission.logic.getLevelTitle) {
            return mission.logic.getLevelTitle();
        }

        let levelNo = "";

        if (this.level.isRegular()) {
            levelNo = cleverapps.user.getVirtualLevel();
        }

        return Messages.get(this.getTitleText(), { levelNo });
    },

    getTitleText: function () {
        if (this.level.isDailyCup()) {
            return "Cups.daily.title";
        }
        if (this.isHardLevel) {
            return "message.hardLevel";
        }
        if (this.level.isTricky()) {
            return "message.trickyLevel";
        }
        if (this.level.isBonus()) {
            return "message.bonusLevel";
        }

        const location = cleverapps.meta.getSelectedLocation();
        if (this.level.isRegular() && location.isLocationCompleted && location.isLocationCompleted()) {
            return "LevelStartWindow.ComingSoonTitle";
        }

        return "LevelStartWindow.title";
    },

    getButton: function () {
        let playButton = {
            button_png: bundles.buttons_main.frames.play_button_png,
            button_on_png: bundles.buttons_main.frames.play_button_on_png
        };

        if (this.isHardLevel) {
            playButton = {
                button_png: bundles.buttons.frames.red_button,
                button_on_png: bundles.buttons.frames.red_button_on
            };
        }

        if (this.level.isTricky() || this.level.isBonus()) {
            playButton = {
                button_png: bundles.buttons.frames.blue_button_png,
                button_on_png: bundles.buttons.frames.blue_button_png
            };
        }

        const params = {
            width: cleverapps.styles.LevelStartWindow.Button.width,
            height: cleverapps.styles.LevelStartWindow.Button.height,
            type: playButton,
            onPressed: () => {
                this.close();

                cleverapps.focusManager.distract({
                    focus: "LevelStartFromLevelStartWindow",
                    action: (f) => {
                        let afterStartActions = [];
                        if (this.boostersBefore) {
                            afterStartActions = afterStartActions.concat(this.boostersBefore.listAfterStartActions());
                        }
                        if (this.isLanternStartWindow()) {
                            afterStartActions = afterStartActions.concat(Lantern.listAfterStartActions(this.level));
                        }

                        this.level.play(f, {
                            boostersBefore: this.boostersBefore && this.boostersBefore.listSelected(),
                            afterStartActions
                        });
                    }
                });
            }
        };

        params.text = Messages.get("Play").toUpperCase();
        return params;
    },

    listContent: function () {
        const styles = cleverapps.styles.LevelStartWindow;
        let data = [];

        if (this.boostersBefore) {
            const boostersBefore = new BoostersBeforeComponent(this.boostersBefore, this.isLanternStartWindow());
            data.push(boostersBefore);

            if (this.isLanternStartWindow()) {
                const lanternStart = new LanternStartComponent(this.level);
                data.push(lanternStart);
            }
        }

        if (this.options.danger) {
            data.push(new cc.Sprite(bundles.level_start_window.frames.start_bg));
        }

        if (this.level.isHard() && bundles.level_start_window.jsons.hard_animation) {
            data = data.concat(this.setCoinsView(bundles.level_start_window.jsons.hard_animation, styles.coinsBg));
        } else if (this.level.isBonus() && !this.isLanternStartWindow()) {
            data = data.concat(this.setCoinsView(bundles.level_start_window.jsons.bonus_animation, styles.coinsBg));
        }

        return data;
    },

    createCoinBadge: function (options) {
        if (!options.danger && !options.lantern) {
            return;
        }

        const styles = cleverapps.styles.LevelStartWindow.lanternStart.coinBadge;

        const coinBadge = new cc.Node();
        coinBadge.setAlignment(styles);

        const labelBundle = bundles.level_start_window.frames.label || bundles.lantern_start.frames.lantern_bonus_label;

        const label = this.coinBadgeLabel = new cc.Sprite(labelBundle);
        label.setAnchorPoint(styles.label.anchor.x, styles.label.anchor.y);
        label.setAlignment(styles.label);

        if (cleverapps.config.ui === "riddles") {
            const labelStyles = options.danger ? styles.label.danger : styles.label;

            const iconBundle = options.danger ? bundles.reward_icons.frames.gold_small_png : bundles.reward_icons.frames.reward_gold_png;

            const rewardIcon = new cc.Sprite(iconBundle);

            if (labelStyles.icon && labelStyles.icon.scale) {
                rewardIcon.setScale(labelStyles.icon.scale);
            }

            let offset = labelStyles.icon.offset;

            rewardIcon.setPosition(label.width / 2 + offset.x, label.height / 2 + offset.y);
            label.addChild(rewardIcon);

            if (labelStyles.text) {
                const rewardText = cleverapps.UI.generateImageText(`+${GameBase.DANGER_REWARD}`, cleverapps.styles.FONTS.LABEL_TEXT);
                rewardText.setRotation(13);

                offset = labelStyles.text.offset;
                rewardText.setPosition(label.width / 2 + offset.x, label.height / 2 + offset.y);

                label.addChild(rewardText);
            }

            const line = new cc.Sprite(bundles.level_start_window.frames.label_line);
            coinBadge.addChild(line, 1);
        }

        if (styles.label.bonusText) {
            const bonusText = cleverapps.UI.generateOnlyText(Messages.get("LevelStartWindow.BonusLabel"), cleverapps.styles.FONTS.LABEL_BONUS_TEXT);
            bonusText.setAlignment(label.width / 2, label.height / 2);
            bonusText.setDimensions(styles.label.bonusText.width, 0);
            bonusText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            bonusText.fitTo(0, styles.label.bonusText.height);
            label.addChild(bonusText);
        }

        if (["riddles", "heroes"].includes(cleverapps.config.ui)) {
            label.setRotation(20);
            label.runAction(new cc.Sequence(
                new cc.RotateBy(0.8, -35),
                new cc.RotateBy(0.8, 25),
                new cc.RotateBy(0.8, -15),
                new cc.RotateBy(0.8, 5)
            )).setFinalize(() => {
                label.setRotation(0);
            });
        }

        coinBadge.addChild(label);

        return coinBadge;
    },

    setCoinsView: function (animationBundle, coinsBg) {
        const data = [];
        let coins;

        if (animationBundle) {
            coins = new cleverapps.Spine(animationBundle);
            coins.setAnimation(0, "animation", true);
        } else {
            coins = new cc.Sprite(bundles.level_start_window.frames.pot_coins_png);
        }

        if (coinsBg) {
            const bg = new cc.Scale9Sprite(bundles.level_start_window.frames.coins_bg_png);
            bg.setContentSize2(coinsBg);
            bg.addChild(coins);
            coins.setAlignment({ align: "center" }, { align: "center" });
            data.push(bg);
        } else {
            data.push(coins);
        }

        return data;
    },

    setCoinsRain: function () {
        if (!cleverapps.styles.LevelStartWindow.coinsRain || !this.level.isBonus()) {
            return;
        }

        const coins = this.coinsRain = new cleverapps.Spine(bundles.level_start_window.jsons.coinsRain);
        const styles = cleverapps.styles.LevelStartWindow;
        coins.setAnimationAndIdleAfter("animation", "idle");
        const scene = cleverapps.Scenes.GetRunningScene();
        scene.addChild(coins);
        coins.setAlignment(styles.coinsRain);
        coins.setLocalZOrder(WindowComponent.WINDOWS_ZORDER - 1);
    },

    isLanternStartWindow: function () {
        return this.options.lantern;
    }
});

LevelStartWindow.isAvailable = function (level) {
    if (["crocword", "woodenblock"].includes(cleverapps.config.name) && (level.isHard() || level.isBonus())) {
        return true;
    }

    const boostersBefore = cleverapps.boosters.listBoostersBefore();

    if (boostersBefore.length === 0) {
        return false;
    }

    if (level.episodeNo === 0 && level.levelNo === 0) {
        return false;
    }

    if (cleverapps.GameSaver) {
        return !cleverapps.GameSaver.load(level.episodeNo, level.levelNo) && WindowBoostersBefore.isAvailable();
    }

    if (cleverapps.config.type === "solitaire") {
        return WindowBoostersBefore.isAvailable();
    }

    return true;
};

LevelStartWindow.prototype.listBundles = function (options) {
    const bundles = ["level_start_window"];

    if (cleverapps.config.features.includes("boosters_before") && WindowBoostersBefore.isAvailable() && typeof Lantern !== "undefined" && Lantern.IsActive(options.level)) {
        if (cleverapps.config.features.includes("lantern_start")) {
            bundles.push("lantern_start");
        } else {
            bundles.push("lantern_element");
        }
    }

    return bundles;
};

cleverapps.override(cleverapps.styles.FONTS, {
    LABEL_TEXT: {
        size: 35
    },

    LABEL_BONUS_TEXT: {
        size: 65,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.LevelStartWindow = {
    Button: {
        width: 300,
        height: 100
    },

    margin: 40,

    lanternStart: {
        margin: 30,

        coinBadge: {
            label: {
                anchor: { x: 0.56, y: 0.83 },
                x: { align: "center", dx: -40 },
                y: { align: "center", dy: -122 },

                icon: {
                    offset: {
                        x: -5,
                        y: -10
                    },

                    scale: 0.7
                },

                danger: {
                    icon: {
                        offset: {
                            x: 2,
                            y: 11
                        }
                    },

                    text: {
                        offset: {
                            x: -20,
                            y: -40
                        }
                    }
                }
            },
            x: { align: "left", dx: 85 },
            y: { align: "top", dy: -53 }
        }
    }
};
